import { useEffect } from "react";
import { useMap } from "react-leaflet";

export function MapResizeHandler() {
  const map = useMap();

  useEffect(() => {
    const handleSidebarToggle = () => {
      // Delay para garantir que a animação CSS da sidebar tenha tempo de completar
      setTimeout(() => {
        map.invalidateSize();
      }, 300);
    };

    window.addEventListener('sidebarToggle', handleSidebarToggle as EventListener);

    return () => {
      window.removeEventListener('sidebarToggle', handleSidebarToggle as EventListener);
    };
  }, [map]);

  return null;
}

